module.exports = __webpack_public_path__ + "static/media/0009.dfbb460.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0009.mp3
// module id = q9PF
// module chunks = 0